import { RefObject, useEffect } from "react";

// Firefox can report mouse wheel steps in lines instead of pixels
const PX_PER_WHEEL_LINE = 16;

const getWheelDeltaInPx = (event: WheelEvent, scroller: HTMLElement) => {
  if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * PX_PER_WHEEL_LINE;
  if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * scroller.clientWidth;
  return event.deltaY;
};

// The mouse wheel scrolls the element sideways, without holding shift. At either end the page scrolls as usual.
export const useHorizontalWheelScroll = (scrollRef: RefObject<HTMLElement>, isActive = true) => {
  useEffect(() => {
    const scroller = scrollRef.current;
    if (!isActive || !scroller) return undefined;
    const onWheel = (event: WheelEvent) => {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      const atStart = scroller.scrollLeft <= 0 && event.deltaY < 0;
      const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1 && event.deltaY > 0;
      if (atStart || atEnd) return;
      event.preventDefault();
      scroller.scrollLeft += getWheelDeltaInPx(event, scroller);
    };
    // Not passive, so the page doesn't scroll at the same time.
    scroller.addEventListener("wheel", onWheel, { passive: false });
    return () => scroller.removeEventListener("wheel", onWheel);
  }, [scrollRef, isActive]);
};
